/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from "react";
import { withOktaAuth } from "@okta/okta-react";
import { FORM_ID } from "../../../../constants/Forms";
import { useDispatch, useSelector } from "react-redux";
import "./CCBIntroForm.scss";
import { loadingStatus } from "../../../../store/state";
import { ccbActions } from "../../../../store/actions";
import { fetchCCB } from "../../../../store/middlewares";
import { CONTRACT_TYPE_DESCRIPTIONS } from "../../../../constants/Contract";
import NavigationButtons from "../../../SharedComponents/NavigationButtons";

const CCBIntroForm = ({
  toggleForm,
  subId: oktaSubId,
  candidateId,
  psrData,
  agencynumber,
  phonenumber,
  updateCCB14CompletedInd,
  updateCCB14Step,
  contractType,
}) => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.ccb14);

  useEffect(() => {
    const fetchData = async () => {
      const { payload } = await dispatch(fetchCCB(oktaSubId));

      const crimdata = payload?.criminaldisclosurestatus || null;
      const regdata = payload?.regulatorystatus || null;
      const civdata = payload?.civiljudstatus || null;
      const custcompldata = payload?.custcomplaintstatus || null;
      const termdiscldata = payload?.terminationdisclstatus || null;
      const financialdiscldata = payload?.financialdisclstatus || null;

      if (crimdata) {
        updateCCB14Step({
          crimDisclosureCompleteStep: crimdata,
        });
        updateCCB14CompletedInd({ crimDisclosureCompleteInd: false });
      }

      if (regdata) {
        updateCCB14Step({
          regActionDisclosureCompleteStep: regdata,
        });
        updateCCB14CompletedInd({ regActionDisclosureCompleteInd: false });
      }

      if (civdata) {
        updateCCB14Step({
          civilJudDisclosureCompleteStep: civdata,
        });
        updateCCB14CompletedInd({ civilJudDisclosureCompleteInd: false });
      }

      if (custcompldata) {
        updateCCB14Step({
          custCompDisclosureCompleteStep: custcompldata,
        });
        updateCCB14CompletedInd({ custCompDisclosureCompleteInd: false });
      }

      if (termdiscldata) {
        updateCCB14Step({
          termDisclosureCompleteStep: termdiscldata,
        });
        updateCCB14CompletedInd({ termDisclosureCompleteInd: false });
      }

      if (financialdiscldata) {
        updateCCB14Step({
          finDisclosureCompleteStep: financialdiscldata,
        });
        updateCCB14CompletedInd({ finDisclosureCompleteInd: false });
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isLoading = loading === loadingStatus.PENDING;
  const isError = error || loading === loadingStatus.FAILED;

  const handleShowBackModal = () => {
    if (psrData > 0 && contractType !== CONTRACT_TYPE_DESCRIPTIONS.MMLIS) {
      toggleForm(FORM_ID.PERSONAL_SALES_RECORD_CHARTS);
    } else if (contractType === CONTRACT_TYPE_DESCRIPTIONS.MMLIS) {
      toggleForm(FORM_ID.EMPLOYMENT_HISTORY);
    } else if (psrData <= 0) {
      toggleForm(FORM_ID.EMPLOYMENT_HISTORY);
    }
  };

  const handleNext = async () => {
    dispatch(ccbActions.setIsBack(false));

    if (loading === loadingStatus.SUCCEDED) {
      dispatch(ccbActions.setCCBCandidateId({ candidateId }));
      toggleForm(FORM_ID.CRIMINAL_DISCLOSURE);
    } else {
      await dispatch(fetchCCB(oktaSubId));

      dispatch(ccbActions.setCCBCandidateId({ candidateId }));
      toggleForm(FORM_ID.CRIMINAL_DISCLOSURE);
    }
  };

  return (
    <div className="ccb-intro-form-container">
      <div className="row">
        <div className="col-md-12">
          <div className="eyebrow" id="ccb_intro_eyebrow">
            <strong>Character, Credit, and Bonding</strong>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <h2 id="ccb_intro_title" style={{ color: "black" }}>
            Form U4 Disclosures
          </h2>
        </div>
      </div>
      <hr></hr>

      <div className="align-self-stretch">
        <div
          className="card--outline"
          style={{ backgroundColor: "#F3F4F6", borderColor: "#FFFFFF" }}
        >
          <div className="card-body">
            <div className="row">
              <h4 className="title col-12">
                <span
                  className="icon-md icon-info"
                  style={cardTextStyle}
                ></span>
                The following section is used for everyone filling out this type
                of application. Some applicants will be seeking registration and
                others won't, but it is a required section and should be filled
                out as thoroughly as possible.
              </h4>
            </div>
            <div
              className="row"
              style={{ display: "flex", alignItems: "center" }}
            >
              <p className="mm-media-object col-12">
                The questions are from the Disclosures section (Section 14) of
                Form U4 and we've retained the specific question numbers for
                easy reference. The Form U4 is the Uniform Application for
                Securities Industry Registration or Transfer. This form is used
                for most applicants of broker-dealers, investment advisers, or
                issuers of securities to become registered in the appropriate
                jurisdictions and/or SROs as well as those not seeking
                registration.
              </p>
              <div className="col-1"></div>
              <p className="mm-media-object col-12">
                Check the appropriate “yes” or “no” response for each question.
                You will be prompted to provide complete details explaining any
                “yes” answers on the appropriate Disclosure Reporting Pages
                (DRPs) at the end of each section.
              </p>
            </div>
          </div>
        </div>
      </div>

      <NavigationButtons
        onBack={handleShowBackModal}
        onNext={handleNext}
        isLoading={isLoading}
        nxtbtnid={"ccb_intro_next"}
        bckbtnid={"ccb_intro_back"}
        nextBtnText="Get Started"
      />
      <div>
        <p>
          <b>Need help? </b>Contact your Agency Licensing Coordinator or Agency
          Supervisory Officer in Agency #{agencynumber} at {phonenumber}
        </p>
      </div>
    </div>
  );
};

export default withOktaAuth(CCBIntroForm);

const cardTextStyle = {
  marginRight: "10px",
};
